import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import PortfolioSummarySkeleton from '@components/Group/Portfolio/Skeleton/PortfolioSummarySkeleton';

const PortfolioInfo = lazy(
  () => import('@components/Group/Portfolio/PortfolioInfo')
);
const PortfolioSummary = lazy(
  () => import('@components/Group/Portfolio/PortfolioSummary')
);

/** 파트너 계정: 조합 관리 > 상세 > 포트폴리오 상세 > 기본정보 */
const BasicInfo = () => {
  return (
    <>
      {/* 포트폴리오 현황 */}
      <ApiErrorBoundary>
        <Suspense fallback={<PortfolioSummarySkeleton />}>
          <PortfolioSummary />
        </Suspense>
      </ApiErrorBoundary>

      {/* 기업정보 + 투자정보 */}
      <ApiErrorBoundary>
        <Suspense>
          <PortfolioInfo />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default BasicInfo;
